import { useEffect, useMemo, useState } from "react";
import { Settings } from "../settings";

// Custom hook to manage window dimensions and calculate symbol size
const useDimensions = () => {
  // State to store the current window dimensions
  const [dimensions, setDimensions] = useState({
    width: window.innerWidth, // Initial width set to the current window width
    height: window.innerHeight, // Initial height set to the current window height
  });

  // Effect to handle window resize events
  useEffect(() => {
    // Function to update dimensions state with current window size
    const handleResize = () => {
      setDimensions({
        width: window.innerWidth, // Update width
        height: window.innerHeight, // Update height
      });
    };

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Call handleResize initially to set dimensions
    handleResize();

    // Cleanup function to remove event listener on component unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty dependency array ensures this effect runs only once

  // Memoized calculation of symbol size based on current width
  const symbolSize = useMemo(() => {
    // Calculate base size using minimum of SYMBOL_SIZE and width divided by REEL_COUNT
    let baseSize = Math.min(
      Settings.SYMBOL_SIZE,
      dimensions.width / Settings.REEL_COUNT
    );

    // Adjust base size if width is less than 1024
    if (dimensions.width < 1024) {
      baseSize *= 0.98; // Reduce size by 2%
    }

    return baseSize; // Return the calculated symbol size
  }, [dimensions.width]); // Recalculate only when width changes

  // Return the current dimensions and calculated symbol size
  return { dimensions, symbolSize };
};

export default useDimensions; // Export the custom hook for use in other components
